import { ExtendableImageProps } from '@design-system/extendable-image';

import { ShoppingCartProps } from '~/components/ShoppingCart/models';
import { buttonMapper } from '~/mappers/button';
import { imageMapper } from '~/mappers/image';
import { quantityButtonMapper } from '~/mappers/quantityButton';

export const shoppingCartMapper = ({
  pageBlockUI: [
    {
      ui: { disableGutters, element, maxWidth, mode },
    },
  ],
  continueShopping,
  productCartItemSettings,
  alertSettings,
  alertButtonSettings,
  paymentOptions: {
    paymentMethods,
    paymentMethodsLabel,
    paymentMethodsLabelUI,
    paymentDescriptionsWithImage,
  },
  cartHeadline: {
    title,
    titleUI,
    description,
    descriptionUI,
    titlePlaceholderToReplace,
    titleReplacedValue,
  },
  cartSummary: {
    totalLabel,
    totalLabelUI,
    subtotalLabel,
    subtotalLabelUI,
    informationLabel,
    informationLabelUI,
    totalAmountLabel,
    totalAmountLabelUI,
    checkoutButton,
    discountCode,
  },
  emptyState: {
    title: emptyStateTitle,
    titleUI: emptyStateTitleUI,
    description: emptyStateDescription,
    descriptionUI: emptyStateDescriptionUI,
    image: emptyStateImage,
  },
  delayedDelivery: { messageDisplayed, delayedDeliveryMessage },
  uid,
  ...rest
}): ShoppingCartProps => ({
  pageBlockUI: {
    disableGutters,
    element,
    maxWidth,
    mode,
  },
  continueShoppingButton: {
    ...buttonMapper(continueShopping),
    link: continueShopping.link.href,
  },
  productCartItemSettings: {
    giftLabel: productCartItemSettings.giftLabel,
    priceLabel: productCartItemSettings.priceLabel,
    quantityButton: quantityButtonMapper(
      productCartItemSettings.quantityButton[0]
    ),
    removeButton: buttonMapper(productCartItemSettings.removeButton),
  },
  alertSettings: {
    alertMessage: alertSettings.message,
    icon: alertSettings.icon,
  },
  alertButtonSettings: {
    confirmButton: buttonMapper(alertButtonSettings.confirmButton),
    declineButton: buttonMapper(alertButtonSettings.declineButton),
  },
  paymentMethodsLabel,
  paymentMethodsLabelUI,
  paymentMethods: paymentMethods.map(({ paymentMethod }) =>
    imageMapper(paymentMethod)
  ),
  paymentDescriptionsWithImage: paymentDescriptionsWithImage.map((item) => ({
    description: item.description,
    descriptionUI: item.descriptionUI,
    image: imageMapper(item.descriptionImage),
  })),
  cartHeadline: {
    title,
    titleUI,
    description,
    descriptionUI,
    titlePlaceholderToReplace,
    titleReplacedValue,
  },
  cartSummary: {
    totalLabel,
    totalLabelUI,
    subtotalLabel,
    subtotalLabelUI,
    informationLabel,
    informationLabelUI,
    totalAmountLabel,
    totalAmountLabelUI,
    checkoutButton: buttonMapper(checkoutButton),
    discountCode: {
      ...discountCode,
      applyButton: buttonMapper(discountCode.applyButton),
      removeButton: buttonMapper(discountCode.removeButton),
    },
  },
  emptyState: {
    emptyStateTitle,
    emptyStateTitleUI,
    emptyStateDescription,
    emptyStateDescriptionUI,
    emptyStateImage: imageMapper(emptyStateImage) as ExtendableImageProps,
  },
  delayedDelivery: {
    messageDisplayed,
    delayedDeliveryMessage,
  },
  uid,
  ...rest,
});
